export default __webpack_public_path__ + "static/mac_fon-aee6e23d20e90106b6d27d8116d8494c.svg";